import { WATCHLIST_STORAGE_KEY } from "~/feature/watchlist/utils/constants";

export const normalizeWatchlistIds = (ids: string[]): string[] =>
  Array.from(new Set(ids.filter(Boolean)));

export const readWatchlistIdsFromStorage = (): string[] => {
  if (typeof window === "undefined") {
    return [];
  }

  const item = window.localStorage.getItem(WATCHLIST_STORAGE_KEY);

  if (item === null) {
    return [];
  }

  try {
    const parsed = JSON.parse(item) as unknown;

    if (!Array.isArray(parsed)) {
      return [];
    }

    return normalizeWatchlistIds(parsed.map(String));
  } catch {
    return [];
  }
};

export const writeWatchlistIdsToStorage = (ids: string[]): void => {
  if (typeof window === "undefined") {
    return;
  }

  const normalized = normalizeWatchlistIds(ids);

  if (normalized.length === 0) {
    window.localStorage.removeItem(WATCHLIST_STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(WATCHLIST_STORAGE_KEY, JSON.stringify(normalized));
};

export const clearWatchlistStorage = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(WATCHLIST_STORAGE_KEY);
};
